import React from "react";
import {
    Box, Chip, Divider,
    Paper,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Typography,
    useTheme
} from "@mui/material";
import {SeasonOverallResults} from "../../schemas/results/season/SeasonOverallResults";
import {Race} from "../../schemas/races/racesSchema";
import {BoatRaceResult} from "../../schemas/results/season/BoatRaceResut";
import dayjs from "dayjs";
import useMediaQuery from "@mui/material/useMediaQuery";

interface AccordionRowOverallProps {
    row: SeasonOverallResults;
    races: Race[];
}

const AccordionRowOverall: React.FC<AccordionRowOverallProps> = ({row, races}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const resultsByRaceId = new Map<number, BoatRaceResult>();
    row.raceResults.forEach(result => {
        resultsByRaceId.set(result.race.id, result);
    });
    const sortedRaces = [...races].sort((a, b) => dayjs(a.date).isBefore(dayjs(b.date)) ? -1 : 1);

    return (
        <Paper elevation={isMobile ? 0 : 1} sx={{px: 1}}>
            <Box sx={{mt: 2, mb: 2}}>
                {isMobile && (
                    <Divider/>
                )}
                <Typography variant="h6" sx={{mb: 1, pt:1}}>
                    Přehled bodů v jednotlivých závodech
                </Typography>
                <Divider/>
                {isMobile ? (
                    <Stack spacing={1}>
                        {sortedRaces.map(race => {
                            const raceResult = resultsByRaceId.get(race.id);
                            const points = raceResult?.points ?? 0;
                            const isDisqualified = !!raceResult?.disqualified;

                            return (
                                <Stack key={race.id} direction="row" justifyContent="space-between" alignItems="center"
                                       sx={{borderBottom: '1px solid #eee', py: 0.5}}>
                                    <Stack>
                                        <Typography fontWeight="bold">{race.name}</Typography>
                                        <Typography variant="caption">{dayjs(race.date).format("DD.MM.YYYY")}</Typography>
                                    </Stack>
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <Typography fontWeight="bold" color="primary.main">
                                            {points}
                                        </Typography>
                                        {isDisqualified && (
                                            <Tooltip title="Diskvalifikován" arrow>
                                                <Chip label="DSQ" color="error" size="small" sx={{height: 18, fontSize: "0.65rem", fontWeight: "bold"}} />
                                            </Tooltip>
                                        )}
                                    </Stack>
                                </Stack>
                            );
                        })}
                    </Stack>
                ) : (
                    <TableContainer sx={{overflowX: "auto"}}>
                        <Table size="small" sx={{minWidth: "100%"}}>
                            <TableHead>
                                <TableRow>
                                    {sortedRaces.map((race) => (
                                        <TableCell key={race.id} align="center">
                                            <Stack direction="column" spacing={0} alignItems="center">
                                                <Typography fontWeight="bold">{race.name}</Typography>
                                                <Typography>{dayjs(race.date).format("DD.MM.YYYY")}</Typography>
                                            </Stack>
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    {sortedRaces.map((race) => {
                                        const raceResult = resultsByRaceId.get(race.id);
                                        const points = raceResult?.points ?? 0;
                                        const isDisqualified = !!raceResult?.disqualified;

                                        return (
                                            <TableCell key={race.id} align="center">
                                                <Stack direction="row" spacing={0.5} justifyContent="center" alignItems="center">
                                                    <Typography fontWeight="bold">
                                                        {points}
                                                    </Typography>
                                                    {isDisqualified && (
                                                        <Tooltip title="Diskvalifikován" arrow>
                                                            <Chip label="DSQ" color="error" size="small" sx={{height: 18, fontSize: "0.65rem", fontWeight: "bold"}} />
                                                        </Tooltip>
                                                    )}
                                                </Stack>
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Box>
        </Paper>
    );
};
export default AccordionRowOverall;